<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
 
<script>
import data from "@/assets/js/date.json";
export default {
    mounted() {
        const result = [];
        const docs = data.item;
        let sortTime = Date.now();

        this.$utils.dfsForest(docs, {
            rCondition: (value) => {
                return value.item && value.item.length > 0;
            },
            hooks: (value, index) => {
                const doc = this.generateDocInterface();
                sortTime += 1000;
                if (value.item) { //存在item则说明为folder
                    this.generateFolder(doc, {
                        docName: value.name,
                        projectId: this.$route.query._id,
                        sort: sortTime + index,
                    });
                    result.push(doc)
                } else { //否则为文档
                    this.generateDoc(doc, {
                        docName: value.name,
                        projectId: this.$route.query._id,
                        sort: sortTime + index,
                        path: value.request.url.path ? ("/" + value.request.url.path.join("/")) : "",
                        methods: value.request.method
                    });
                    //生成文档header
                    value.request.header.forEach(val => { 
                        doc.item.header.push({
                            key: val.key,
                            type: "string",
                            value: val.value,
                            description: val.description,
                            required: true
                        });
                    });
                    //将query转换为请求参数,注意一个请求参数既存在query又存在body将被认定为不规范数据，处理策略全部转换为查询参数
                    value.request && value.request.query && value.request.query.forEach(val => { //requestParams
                        doc.item.requestParams.push({
                            key: val.key,
                            type: "string",
                            value: val.value,
                            description: val.description,
                            required: true
                        });
                    });    
                    //将requestBody转换为请求参数
                    if (value.request.body && value.request.body.mode === "raw") {
                        const raw = JSON.parse(value.request.body.raw);
                        this.$utils.dfsTree(raw, {
                            rCondition: (value) => {
                                return this.$utils.getTag(value) === "object";
                            },
                            hooks: (key, value) => {
                                // let type = "";
                                // let realValue = value;
                                // if (this.$utils.getTag(value) === "string") {
                                //     type = "string"
                                // } else if (this.$utils.getTag(value) === "number") {
                                //     type = ""
                                // }
                                // doc.item.requestParams.push({
                                //     key: key,
                                //     type: "string",
                                //     value: val.value,
                                //     description: val.description,
                                //     required: true
                                // });
                                // console.log(key, value)
                            },
                        });
                        // console.log(raw)
                    }
                    result.push(doc)
                }
            },
            rKey: "item"
        });
        
        // console.log(result);
        // console.log(docs);
    },
    methods: {
        //生成文档基础数据
        generateDocInterface() {
            return {
                item: {
                    url: {
                        host: "",
                        path: ""
                    },
                    description: "",
                    methods: "",
                    header: [],
                    requestParams: [],
                    responseParams: [],
                    otherParams: []
                },
                pid: "",
                ancestors: [],
                docName: "",
                isFolder: false,
                projectId: "",
                sort: 0,
                enabled: true,
                publish: false
            };
        },
        //生成基础folder, 会改变第一个参数值
        generateFolder(doc, config) {
            doc.isFolder = true;
            doc.docName = config.docName;
            doc.projectId = config.projectId;
            doc.sort = config.sort;
        },
        //生成文档
        generateDoc(doc, config) {
            doc.isFolder = false;
            doc.docName = config.docName;
            doc.projectId = config.projectId;
            doc.sort = config.sort;
            doc.path = config.path;
            doc.methods = config.methods;
        },
    }
};
</script>

 

<style lang="scss">
#app {
    height: 100%;
}
</style>
